import Controller from "./credits.controller";
import template from "./credits.html";

const credits = {
  template,
  controller: Controller,
};

export default credits;



// WEBPACK FOOTER //
// ./src/pages/credits/credits.component.js